import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Sidebar from './components/Sidebar';
import Notification from './components/Notification';

// Pages
import Dashboard from './pages/Dashboard';
import Prospecting from './pages/Prospecting';
import CustomerDetail from './pages/CustomerDetail';
import SPK from './pages/SPK';
import Delivery from './pages/Delivery';
import LeadManagement from './pages/LeadManagement';
import TeamManagement from './pages/TeamManagement';
import Calendar from './pages/Calendar';
import PerformanceDashboard from './pages/PerformanceDashboard';
import Reports from './pages/Reports';
import Settings from './pages/Settings';

function Layout({ children }) {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="p-6 animate-fade-in">
          {children}
        </div>
      </main>
      <Notification />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/prospecting" element={<Prospecting />} />
            <Route path="/prospecting/:id" element={<CustomerDetail />} />
            <Route path="/spk" element={<SPK />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/lead-management" element={<LeadManagement />} />
            <Route path="/team" element={<TeamManagement />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/performance" element={<PerformanceDashboard />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </Layout>
      </Router>
    </AppProvider>
  );
}
